import { useEffect } from "react";

import { TextField } from "@material-ui/core/";

import Calendar from "../../../assets/icons/Calendar.svg";

import { Container, makeStyles } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import { Autocomplete } from "@material-ui/lab";
import { useState } from "react";
import { useHistory } from "react-router-dom";
import { useGlobal } from "../../../contexts/globalContext";
import CitiesRepository from "../../../repositories/citiesRepository";
import { getExperienceCategories } from "../../../repositories/getExperienceCategories";
import { getExperienceSubcategories } from "../../../repositories/getExperienceSubcategories";
import cleanStorageBeforeSearch from "../../../utils/cleanStorageBeforeSearch";
import InputDateRange from "../../InputDateRange";
import ThemeButton from "../../ThemeButton";
import * as S from "./styles";

import { getSessionStorage } from "../../../utils/getSessionStorage";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiFormHelperText-root.Mui-error": {
      color: "white",
    },
    opacity: 1,
    "& .MuiInputBase-input": {
      color: `#FFF`,
    },
    "& label.Mui-focused": {
      color: `#FFF`,
    },
    "& .MuiFormLabel-root": {
      color: "#FFF",
      opacity: 0.45,
    },
    "& .MuiSelect-icon": {
      color: "#FFF",
    },
    "& .MuiAutocomplete-popupIndicator": {
      color: "#FFF",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: `#FFF`,
        color: `#FFF`,
      },
      "&:hover fieldset": {
        borderColor: `#FFF`,
        color: `#FFF`,
        borderWidth: 2,
      },
      "&.Mui-focused fieldset": {
        borderColor: `#FFF`,
        color: `#FFF`,
      },
      "&.Mui-error fieldset": {
        borderColor: "#FFF",
      },
    },
  },
}));

const ExperiencesSearchInputs = () => {
  const { user } = useGlobal();
  let history = useHistory();
  const classes = useStyles();
  const citiesRepository = new CitiesRepository();

  const initialState = {
    categoria: "",
    subcategoria: "",
    cidade: "",
    datas: "",
  };
  const [state, setState] = useState(initialState);
  const [options, setOptions] = useState([]);
  const [categories, setCategories] = useState([]);
  const [subcategories, setSubcategories] = useState([]);

  // US-17: carrega categorias da campanha ativa (campanha resolvida no backend pelo token).
  useEffect(() => {
    getExperienceCategories()
      .then((res) => setCategories(Array.isArray(res.data) ? res.data : []))
      .catch(() => setCategories([]));
  }, []);

  // US-19: subcategorias dependentes da categoria selecionada.
  useEffect(() => {
    if (state.categoria && state.categoria.id) {
      getExperienceSubcategories(state.categoria.id)
        .then((res) => setSubcategories(Array.isArray(res.data) ? res.data : []))
        .catch(() => setSubcategories([]));
    } else {
      setSubcategories([]);
    }
  }, [state.categoria]);

  const changeOptions = (value) => {
    if (value.length >= 3) {
      citiesRepository.getCities(value).then((cities) => {
        setOptions(cities.data || []);
      });
    }
  };

  const handleSubmit = () => {
    // US-18: cidade e data deixaram de ser obrigatorias. Categoria/subcategoria tambem
    // sao opcionais (categoria "Todos" = nada selecionado -> tudo da campanha).
    cleanStorageBeforeSearch();
    sessionStorage.setItem("experienceSearch", JSON.stringify(state));
    sessionStorage.setItem("buscaAtual", "Experiencias");
    history.push("/busca/resultado-pesquisa");
  };

  useEffect(() => {
    if (state !== initialState) {
      sessionStorage.setItem("experienceSearch", JSON.stringify(state));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state]);

  useEffect(() => {
    const exp = getSessionStorage("experienceSearch");
    if (exp) setState(exp);
  }, []);

  return (
    <S.Wrapper>
      <Container>
        <div className="origem-destino-control">
          <Grid container spacing={3}>
            {/* US-17: navegador inicial de categorias */}
            <Grid item xs={12} sm={6} md={3} lg={3}>
              <Autocomplete
                className={classes.root}
                noOptionsText="Não encontrado"
                options={categories}
                getOptionLabel={(option) => (option ? option.name || "" : "")}
                getOptionSelected={(option, value) => option.id === value.id}
                onChange={(event, newValue) => {
                  // ao trocar a categoria, limpa a subcategoria previamente escolhida
                  setState({ ...state, categoria: newValue || "", subcategoria: "" });
                }}
                value={state.categoria !== "" ? state.categoria : null}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder="Selecione uma categoria"
                    variant="outlined"
                    fullWidth
                    className={classes.root}
                  />
                )}
              />
            </Grid>
            {/* US-19: subcategoria dependente da categoria */}
            <Grid item xs={12} sm={6} md={3} lg={2}>
              <Autocomplete
                className={classes.root}
                noOptionsText="Não encontrado"
                options={subcategories}
                disabled={!state.categoria || !state.categoria.id}
                getOptionLabel={(option) => (option ? option.name || "" : "")}
                getOptionSelected={(option, value) => option.id === value.id}
                onChange={(event, newValue) => {
                  setState({ ...state, subcategoria: newValue || "" });
                }}
                value={state.subcategoria !== "" ? state.subcategoria : null}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder="Subcategoria"
                    variant="outlined"
                    fullWidth
                    className={classes.root}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3} lg={2}>
              <Autocomplete
                freeSolo
                disableClearable
                className={classes.root}
                noOptionsText="Não encontrado"
                options={options}
                getOptionLabel={(option) =>
                  option
                    ? `${option.cityName}${
                        option.stateName ? `, ${option.stateName}` : ""
                      }`
                    : ""
                }
                onInputChange={(event, value, reason) => {
                  if (reason === "input") {
                    changeOptions(value);
                  }
                }}
                onChange={(event, newValue) => {
                  setState({ ...state, cidade: newValue });
                }}
                filterOptions={(x) => x}
                value={state.cidade !== "" ? state.cidade : ""}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder="Cidade (opcional)"
                    variant="outlined"
                    fullWidth
                    className={classes.root}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3} lg={2}>
              <InputDateRange
                icon={Calendar}
                label="Data (opcional)"
                width={190}
                value={state.datas.abreviada}
                onChange={(e) => setState({ ...state, datas: e })}
                minStartDays={
                  user.campaign.advanceDaysExperience
                    ? user.campaign.advanceDaysExperience
                    : 1
                }
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={3}>
              <ThemeButton onClick={handleSubmit} className="submit1">
                Buscar
              </ThemeButton>
            </Grid>
          </Grid>
        </div>
      </Container>
    </S.Wrapper>
  );
};

export default ExperiencesSearchInputs;
